import axios from "axios";
import { getAuthHeader } from "../utils/authHeader";
import { Plan } from "../Admin/types";

class PlanService {
    private baseUrl: string;

    constructor() {
        this.baseUrl = process.env.REACT_APP_BACKEND_URL!;
    }

    async getAllPlans(): Promise<Plan[]> {
        try {
            const headers = await getAuthHeader();
            const response = await axios.get(`${this.baseUrl}/onboarding/plans`, {
                headers,
            });

            if (response.status !== 200) {
                throw new Error("Failed to fetch plans.");
            }

            return response.data;
        } catch (error: unknown) {
            console.error("Failed to fetch plans:", error);
            throw new Error("Failed to fetch plans");
        }
    }
}

export const planService = new PlanService();